// extracted by mini-css-extract-plugin
module.exports = {"spinner":"SvgSpinner_spinner__3nO-B","spin":"SvgSpinner_spin__xnFqj"};